import React, { useState } from 'react';
import { Table, Button, Input, Space, Tag } from 'antd';
import { PlusOutlined, SearchOutlined, EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import './SupplierManagementPage.css';

interface Supplier {
  id: string;
  stt: number;
  name: string;
  code: string;
  contactPerson: string;
  phone: string;
  email: string;
  address: string;
  status: 'active' | 'inactive';
}

const SupplierManagementPage: React.FC = () => {
  const [searchText, setSearchText] = useState('');

  // Mock data
  const mockData: Supplier[] = [
    {
      id: '1',
      stt: 1,
      name: 'Công ty Dược phẩm ABC',
      code: 'SUP001',
      contactPerson: 'Nguyễn Văn A',
      phone: '0901234567',
      email: 'contact@abc.com',
      address: '123 Đường ABC, Quận 1, TP.HCM',
      status: 'active',
    },
    {
      id: '2',
      stt: 2,
      name: 'Nhà cung cấp Thiết bị Y tế XYZ',
      code: 'SUP002',
      contactPerson: 'Trần Thị B',
      phone: '0912345678',
      email: 'info@xyz.com',
      address: '456 Đường XYZ, Quận 2, TP.HCM',
      status: 'active',
    },
  ];

  const columns: ColumnsType<Supplier> = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      width: 60,
      align: 'center',
    },
    {
      title: 'Tên nhà cung cấp',
      dataIndex: 'name',
      key: 'name',
      width: 250,
    },
    {
      title: 'Mã',
      dataIndex: 'code',
      key: 'code',
      width: 100,
    },
    {
      title: 'Người liên hệ',
      dataIndex: 'contactPerson',
      key: 'contactPerson',
      width: 150,
    },
    {
      title: 'Điện thoại',
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 200,
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address',
      width: 250,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status: string) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? 'Hoạt động' : 'Không hoạt động'}
        </Tag>
      ),
    },
    {
      title: 'Tùy chọn',
      key: 'actions',
      width: 120,
      fixed: 'right',
      render: () => (
        <Space>
          <Button type="link" icon={<EditOutlined />} />
          <Button type="link" icon={<EyeOutlined />} />
          <Button type="link" icon={<DeleteOutlined />} danger />
        </Space>
      ),
    },
  ];

  const filteredData = mockData.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase()) ||
    item.code.toLowerCase().includes(searchText.toLowerCase()) ||
    item.contactPerson.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="supplier-management-page">
      <div className="page-header">
        <h1>Quản lý nhà cung cấp</h1>
        <Button type="primary" icon={<PlusOutlined />} size="large">
          Tạo mới nhà cung cấp
        </Button>
      </div>
      <div className="page-toolbar">
        <Input
          placeholder="Tìm kiếm"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 300 }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        pagination={{
          current: 1,
          pageSize: 10,
          total: filteredData.length,
          showSizeChanger: false,
        }}
        scroll={{ x: 1400 }}
      />
    </div>
  );
};

export default SupplierManagementPage;
